<template>
	<section class="black-list-panel">
		<div class="panel-heading">
			<div>
				<h3>黑名单 IP</h3>
				<p>共 {{ total }} 个已拦截来源，移除后将恢复该 IP 的访问权限。</p>
			</div>
			<el-tag type="danger" effect="light">拦截生效中</el-tag>
		</div>
		<div class="filter-bar">
			<el-input v-model.trim="listQuery.ip" clearable placeholder="输入完整 IP 地址" prefix-icon="el-icon-search" @keyup.enter.native="handleFilter" />
			<el-button type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
			<el-button type="danger" plain icon="el-icon-warning-outline" @click="addBlacklist">手动拉黑</el-button>
			<el-button icon="el-icon-refresh" @click="resetFilter">重置</el-button>
		</div>

		<el-table v-loading="listLoading" :data="list" class="black-table" :height="height" empty-text="暂无已拦截 IP" row-key="id">
			<el-table-column label="IP 地址" prop="ip" min-width="190"
				><template slot-scope="{ row }"
					><span class="ip-value">{{ row.ip }}</span></template
				></el-table-column
			>
			<el-table-column label="关联域名" prop="domain" min-width="220" show-overflow-tooltip
				><template slot-scope="{ row }">{{ row.domain || '后台手动添加' }}</template></el-table-column
			>
			<el-table-column label="拉黑时间" prop="created_at" min-width="180" />
			<el-table-column label="操作" width="110" align="right"
				><template slot-scope="{ row }"><el-button type="text" class="restore-action" @click="handleDelete(row)">移出黑名单</el-button></template></el-table-column
			>
		</el-table>
		<pagination v-if="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.pagesize" @pagination="getList" />
	</section>
</template>

<script>
	export default {
		name: 'BlackIpList',
		data() {
			return { listQuery: { page: 1, pagesize: 20, ip: '' }, total: 0, list: [], listLoading: true };
		},
		computed: {
			height() {
				return this.$baseTableHeight();
			}
		},
		created() {
			this.getList();
		},
		methods: {
			handleFilter() {
				this.listQuery.page = 1;
				this.getList();
			},
			resetFilter() {
				this.listQuery.ip = '';
				this.handleFilter();
			},
			getList() {
				this.listLoading = true;
				this.request
					.get('/ipblack-list', { params: this.listQuery })
					.then((ret) => {
						this.list = ret.list || [];
						this.total = ret.count || 0;
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			handleDelete(row) {
				this.$baseConfirm(`确定移除 ${row.ip} 的黑名单吗？`, '恢复访问', () => {
					this.request.post('/ipblack-remove', { id: row.id }).then(() => {
						this.$message.success('已移出黑名单');
						this.getList();
					});
				});
			},
			addBlacklist() {
				this.$prompt('请输入要拉黑的 IPv4 或 IPv6 地址', '手动加入黑名单', { inputPattern: /.+/, inputErrorMessage: 'IP不能为空' })
					.then(({ value }) =>
						this.request.post('/ipblack-add', { ip: value.trim() }).then(() => {
							this.$message.success('已加入黑名单');
							this.getList();
						})
					)
					.catch(() => {});
			}
		}
	};
</script>

<style scoped>
	.panel-heading {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
	}
	.panel-heading h3 {
		margin: 0;
		color: #24324a;
		font-size: 18px;
	}
	.panel-heading p {
		margin: 7px 0 0;
		color: #8491a8;
		font-size: 13px;
	}
	.filter-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
		margin-bottom: 18px;
		padding: 14px;
		border-radius: 8px;
		background: #fff8f7;
	}
	.filter-bar .el-input {
		width: 220px;
	}
	.black-table {
		border: 1px solid #f2e8e8;
		border-radius: 8px;
		overflow: hidden;
	}
	.ip-value {
		color: #303b4f;
		font-family: Monaco, Consolas, monospace;
	}
	.restore-action {
		color: #2e8b57;
	}
	@media (max-width: 640px) {
		.filter-bar .el-input {
			width: 100%;
		}
	}
</style>
